<template>
  <div class="newPer" v-wechat-title="title">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"

    >
      <img :src="bannerImg" width="100%">
      <div style="background-color: #fff;padding: 0.2rem 0.15rem;">
        <ul>
          <li v-for="(item, index) of list" :key="index" @click="newPerClick(item)">
            <img v-lazy="item.img_path">
            <div class="proMess">
              <div class="tags">
                <p v-if="item.tag1">{{item.tag1}}</p>
                <p v-if="item.tag2">{{item.tag2}}</p>
                <p v-if="item.tag3">{{item.tag3}}</p>
                <!--<p>产品卖点</p>-->
              </div>
              <b>{{item.name}}</b>
              <div class="span">
                <div class="goods_price">
                  <span class="smallprice">
                    <sub>¥</sub>
                    <b>{{String(parseFloat(item.sales_price).toFixed(2)).slice(0, String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'))}}</b>
                    <sup>{{String(parseFloat(item.sales_price).toFixed(2)).slice(String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'), String(parseFloat(item.sales_price).toFixed(2)).length)}}</sup>
                  </span>
                </div>
                <i>¥{{item.cost_price}}</i>
              </div>
            </div>
            <div class="clear"></div>
          </li>
        </ul>
      </div>
    </Scroller>
  </div>
</template>

<script>
import { fenxiang } from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
export default {
  name: 'newProduct',
  data () {
    return {
      list: [],
      bannerImg: '',
      title: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },
  components: {
    Scroller
  },
  mounted: function () {
    window.scrollTo(0, 0)
    fenxiang({path: 'newproduct'})
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter (to, from, next) {
    console.log('------from------', from)
    if (from.path == '/' && from.name != 'homePage') { // 当前页面刷新不需要切换位置
      next(vm => {
        // console.log(from.path)
        vm.nowPage = 0
      })
    } else {
      next(vm => {})
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function () {
      var url
      if (this.$route.query.type == 1) {
        this.title = this.$route.meta.title = this.$route.query.title
        url = this.$ajax.getHotItemList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
        console.log(this.$route.query.type, url)
      } else if (this.$route.query.type == 2) {
        this.title = this.$route.meta.title = '新品上市'
        url = this.$ajax.getNewItemList_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
        console.log(this.$route.query.type, url)
      }
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (that.nowPage == 1) {
            that.list = res.data.itemlist
            that.bannerImg = res.data.bannerimg
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.itemlist)
            that.bannerImg = res.data.bannerimg
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    newPerClick: function (items) {
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      this.getData()
    },
    onInfinite () {
      console.log('onInfinite')
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    }
  }
}
</script>

<style scoped lang="scss">
.newPer {
  background: #fff;
  min-height: 100%;
  >img {
    width: 100%;
  }
  ul {
    /*margin: 0.2rem 0.15rem;*/
    li{
      width: 100%;
      margin-bottom: 0.15rem;
      .clear {
        clear: both;
      }
      &:last-of-type{
        margin-bottom: 0;
      }
      &:nth-of-type(2n-1) {
        >img {
          float: left;
        }
        .proMess {
          float: right;
          padding-left: 0.15rem;
        }
      }
      &:nth-of-type(2n) {
        >img {
          float: right;
        }
        .proMess {
          float: left;
          padding-right: 0.15rem;
        }
      }
      >img {
        width: 1.44rem;
        height: 1.44rem;
      }
      .proMess {
        width: 58%;
        padding: 0.14rem 0;
        .tags {
          overflow: hidden;
          p {
            width: 0.56rem;
            font-size: 0.12rem;
            font-weight:400;
            color:rgba(254,73,62,1);
            line-height:0.19rem;
            height:0.19rem;
            border:1px solid rgba(254,73,62,1);
            text-align: center;
            border-radius: 0.01rem;
            margin-right: 0.04rem;
            float: left;
          }
        }

        >b {
          font-size:0.13rem;
          font-weight:400;
          color:rgba(41,41,41,1);
          line-height:0.18rem;
          display: block;
          margin: 0.07rem 0 0.26rem;
          height: 0.36rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .span {
          display: block;
          margin-bottom: 0.06rem;
          overflow: hidden;
          font-size: 0;
          .goods_price{
            font-size: 0.24rem;
            font-weight:400;
            color:rgba(48,48,48,1);
            display: inline-block;
            padding: 0 0.12rem;
            background:linear-gradient(left,rgba(255,220,187,1) 0%,rgba(254,248,237,1) 48%,rgba(255,227,200,1) 100%);
            background: -moz-linear-gradient(left,rgba(255,220,187,1) 0%,rgba(254,248,237,1) 48%,rgba(255,227,200,1) 100%);
            background: -ms-linear-gradient(left,rgba(255,220,187,1) 0%,rgba(254,248,237,1) 48%,rgba(255,227,200,1) 100%);
            background: -o-linear-gradient(left,rgba(255,220,187,1) 0%,rgba(254,248,237,1) 48%,rgba(255,227,200,1) 100%);
            background: -webkit-linear-gradient(left,rgba(255,220,187,1) 0%,rgba(254,248,237,1) 48%,rgba(255,227,200,1) 100%);
            .smallprice {
              font-size: 0;
              b {
                font-size: 0.24rem;
                font-weight:400;
                color:rgba(48,48,48,1);
              }
            }
            sub {
              font-size:0.13rem;
              font-weight:400;
              vertical-align: baseline
            }
            sup {
              font-size: 0.13rem;
              vertical-align: baseline;
              font-weight: 400;
            }
          }
          >i {
            margin-left: 0.11rem;
            font-style: normal;
            font-size:0.11rem;
            display: inline-block;
            vertical-align: baseline;
            font-weight:400;
            color:rgba(108,108,108,1);
            line-height:0.16rem;
            text-decoration: line-through ;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/newProduct.vue